<template>
	<div
		v-if="isModalOpen"
		class="z-maximumPlusUltraMinusOne fixed top-0 left-0 table h-full w-full bg-black/50"
	>
		<div class="table-cell align-middle">
			<div
				class="relative mx-auto max-w-[360px] rounded-xl bg-white py-6 px-4 shadow-lg md:max-w-[405px] lg:max-w-[470px] lg:px-5"
			>
				<div
					class="absolute right-4 top-4 h-6 w-6 cursor-pointer"
					@click="handleDialogsClose"
				>
					<CloseSvg class="fill-secondary" />
				</div>

				<div class="mb-4 flex justify-center">
					<WarningSvg class="fill-main-400" />
				</div>

				<div class="mb-8">
					<h3 class="text-main-400 text-20 md:text-24 lg:text-28 text-center font-bold">
						{{ modalTitle }}
					</h3>
				</div>

				<div
					v-if="
						dialogs.errorModal.open &&
						dialogs.errorModal.type === 'vin' &&
						!dialogs.errorModal.isOld
					"
					class="mb-8 lg:pl-3"
				>
					<div class="flex items-center">
						<div class="mr-3">
							<CheckSecondSvg class="fill-main-400 w-5 lg:w-6" />
						</div>
						<div class="text-primary text-base lg:text-xl">
							<p>A VIN cannot include letters I, O, Q</p>
						</div>
					</div>

					<div class="flex items-center">
						<div class="mr-3">
							<CheckSecondSvg class="fill-main-400 w-5 lg:w-6" />
						</div>
						<div class="text-primary text-base lg:text-xl">
							<p>A VIN is made up of 17 characters</p>
						</div>
					</div>
				</div>

				<div>
					<h4 class="text-main-400 text-18 md:text-20 text-center font-bold">
						{{ bottomText }}
					</h4>
				</div>

				<div v-if="dialogs.mileageErrorData.isModalOpen" class="mt-5 flex justify-center">
					<AppButton
						class="xs:basis-0 text-md xs:text-base min-w-[190px] basis-2/3"
						size="Normal"
						@click="onNextStep"
					>
						<span>Continue</span>
					</AppButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import WarningSvg from '../../VehicleForm/components/icons/WarningSvg.vue'
	import AppButton from '../../common/AppButton.vue'
	import CloseSvg from '../../VehicleForm/components/icons/CloseSvg.vue'
	import CheckSecondSvg from '../../VehicleForm/components/icons/CheckSecondSvg.vue'
	import { useDialogStore } from '../../../stores/dialog'
	import { useFormStore } from '../../../stores/form'

	const form = useFormStore()
	const dialogs = useDialogStore()

	const isModalOpen = computed(() => {
		return dialogs.errorModal.open || dialogs.mileageErrorData.isModalOpen
	})

	const modalTitle = computed(() => {
		if (dialogs.errorModal.open) return dialogs.errorModal.title
		if (dialogs.mileageErrorData.isModalOpen) {
			return `Uh-Oh, the mileage entered  (${mileageFilter(
				dialogs.mileageErrorData.mileage,
			)} miles) seems ${dialogs.mileageErrorData.isTooMuch ? 'high' : 'low'} for the year!`
		}
		return ''
	})

	const bottomText = computed(() => {
		if (dialogs.errorModal.open) return dialogs.errorModal.subtitle
		if (dialogs.mileageErrorData.isModalOpen) {
			return 'Please enter the correct mileage or click "continue" if it looks good.'
		}
		return ''
	})

	const handleDialogsClose = () => {
		dialogs.mileageErrorData.isModalOpen = false
		dialogs.closeErrorModal()
	}

	const onNextStep = () => {
		form[form.currentStep.action]().finally(() => handleDialogsClose())
	}

	const mileageFilter = (mil: number) => {
		const numberFormatter = Intl.NumberFormat('en-US')
		return numberFormatter.format(mil)
	}
</script>
